import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCart } from '../context/CartContext';
import './Toast.css';

export default function Toast() {
  const { toastVisible, hideToast } = useCart();
  const { t } = useTranslation();

  if (!toastVisible) return null;

  return (
    <div className="cart-toast" role="alert" aria-live="polite">
      <svg className="cart-toast__icon" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
        aria-hidden="true">
        <polyline points="20 6 9 17 4 12" />
      </svg>
      <span className="cart-toast__msg">
        {t('cart.addedToCart', 'Shtuar në shportë')}
      </span>
      <Link
        to="/checkout"
        className="cart-toast__cta"
        onClick={hideToast}
      >
        {t('cart.goToCheckout', 'Shko te Kasa')} →
      </Link>
      <button
        type="button"
        className="cart-toast__close"
        onClick={hideToast}
        aria-label={t('common.close', 'Close')}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
}
